import { createEndpoint } from '@/shared/models/api';
import { IdValue } from '@/app/api/morgan-thermal';

export type Region = IdValue;

export const getRegions = createEndpoint<Region[]>(({ fetch }) => () => fetch('/Configuration/GetRegions'));